"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicHandleRequestT = exports.TopicHandleRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const topic_id_js_1 = require("../../solarxr-protocol/pub-sub/topic-id.js");
/**
 * Request to get the `FeatureHandle` from a `FeatureId`. This is useful for reducing
 * bandwidth, since `FeatureId` can be large.
 */
class TopicHandleRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTopicHandleRequest(bb, obj) {
        return (obj || new TopicHandleRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTopicHandleRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TopicHandleRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new topic_id_js_1.TopicId()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startTopicHandleRequest(builder) {
        builder.startObject(1);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static endTopicHandleRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTopicHandleRequest(builder, idOffset) {
        TopicHandleRequest.startTopicHandleRequest(builder);
        TopicHandleRequest.addId(builder, idOffset);
        return TopicHandleRequest.endTopicHandleRequest(builder);
    }
    unpack() {
        return new TopicHandleRequestT((this.id() !== null ? this.id().unpack() : null));
    }
    unpackTo(_o) {
        _o.id = (this.id() !== null ? this.id().unpack() : null);
    }
}
exports.TopicHandleRequest = TopicHandleRequest;
class TopicHandleRequestT {
    constructor(id = null) {
        this.id = id;
    }
    pack(builder) {
        const id = (this.id !== null ? this.id.pack(builder) : 0);
        return TopicHandleRequest.createTopicHandleRequest(builder, id);
    }
}
exports.TopicHandleRequestT = TopicHandleRequestT;
